import {block} from '../utils/cn';

export const sheetBlock = block('sheet');

export const SheetQa = {
    VEIL: 'sheet-veil',
};
